// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10gc_","col":"styles_col__3Yrvh","actions":"styles_actions__raRFC","conflict":"styles_conflict__1iho5"};